import React from 'react';
import Glider from "./Glider";
export const Carousel = _ref => {
  let {
    slidesToShow = 3.2,
    slidesToScroll = 1,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Glider, {
    draggable: true,
    hasArrows: true,
    scrollLock: true,
    dragVelocity: 1,
    duration: 1,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll
  }, children);
};